import Link from "compat/Link";
import { Container, Title, Text, Card, Image, Grid, Group, Divider, Blockquote } from "@mantine/core";
import { IconQuote } from "@tabler/icons-react";
import { blogPosts } from 'common/data/AppCreative';
import ShareBar from "containers/ShareBar";

export interface BlogPostParagraph {
    subtitle: string;
    content: string;
}

export interface BlogPostQuote {
    quote: string;
    name: string;
}

export interface BlogPost {
    id: string;
    title: string;
    image: string;
    date: string;
    description?: string;
    content: BlogPostParagraph[];
    quotes: BlogPostQuote[];
}

export interface BlogPostContentProps {
    post: BlogPost;
}

const BlogPostContent = ({ post }: BlogPostContentProps) => {
    const relatedPosts = (blogPosts as BlogPost[]).filter((p) => p.id !== post.id);
    if (!post) return <Text align="center" size="lg">Post not found</Text>;

    return (
        <Container size="md" mt={'xl'} key={post.id}>
            {/* <Paper shadow="xs" p="xl" radius="md" mt="xl" style={{ lineHeight: 1.7 }}> */}
            <Image src={post.image} alt={post.title} radius="md" mb="md" style={{ width: "100%", objectFit: "cover" }} />

            <Title order={1} align="center" mb="md" style={{ fontSize: "2.5rem", fontWeight: 700 }}>{post.title}</Title>

            <Text size="sm" color="dimmed" align="center" mb="md">{post.date}</Text>
            {post.content.slice(0, 2).map((paragraph, index) => (
                <Container>
                    <Text key={index} mt="md" size="lg" style={{ fontSize: "1.1rem", textAlign: "justify", fontWeight: 'bold', whiteSpace: 'pre-line' }}>{paragraph.subtitle}</Text>
                    {/* <Text key={index} mt="md" size="lg" style={{ fontSize: "1.1rem", textAlign: "justify", whiteSpace:'pre-line'}}>{paragraph.content}</Text> */}
                    <Text
                        key={index}
                        mt="md"
                        size="lg"
                        style={{ fontSize: "1.1rem", textAlign: "justify", whiteSpace: 'pre-line' }}
                        dangerouslySetInnerHTML={{ __html: paragraph.content }}
                    />
                </Container>
            ))}

            {post.quotes.length > 0 && (
                <>
                    <Divider my="xl" />
                    <Blockquote icon={<IconQuote size={20} />} cite={post.quotes[0].name} style={{ fontSize: "1.2rem", fontStyle: "italic", textAlign: "center" }}>
                        {post.quotes[0].quote}
                    </Blockquote>
                    <Divider my="xl" />
                </>
            )}

            {post.content.slice(2).map((paragraph, index) => (
                <Container>
                    <Text key={index} mt="md" size="lg" style={{ fontSize: "1.1rem", textAlign: "justify", fontWeight: 'bold', whiteSpace: 'pre-line' }}>{paragraph.subtitle}</Text>
                    {/* <Text key={index} mt="md" size="lg" style={{ fontSize: "1.1rem", textAlign: "justify", whiteSpace:'pre-line' }}>{paragraph.content}</Text> */}
                    <Text
                        key={index}
                        mt="md"
                        size="lg"
                        style={{ fontSize: "1.1rem", textAlign: "justify", whiteSpace: 'pre-line' }}
                        dangerouslySetInnerHTML={{ __html: paragraph.content }}
                    />
                </Container>
            ))}

            {/* {post.extraImages.map((image, index) => (
                    <Image key={index} src={image} alt={`Extra ${index + 1}`} radius="md" mt="xl" style={{ width: "100%", maxHeight: 400, objectFit: "cover" }} />
                ))} */}
            <Group position="right" mt="xl">
                <ShareBar url={`https://www.linoktech.com/blog/${post.id}`} title={post.title} />
            </Group>
            {/* </Paper> */}

            <Divider my="xl" />

            {relatedPosts.length > 0 &&
                <>
                    <Title order={2} mt="xl" mb="md" style={{ fontSize: "2rem", fontWeight: 600 }}>Related Posts</Title>
                    <Grid mt="md">
                        {relatedPosts.map((post) => (
                            <Grid.Col span={12} sm={6} md={4} key={post.id}>
                                <Card shadow="sm" p="lg" radius="md" mb="lg" style={{ transition: "0.3s", cursor: "pointer" }}>
                                    <Image src={post.image} alt={post.title} radius="md" height={180} style={{ objectFit: 'cover' }} />
                                    <Title order={4} mt="md" style={{ fontSize: "1.2rem", fontWeight: 600 }}>
                                        <Link href={`/blog/${post.id}`} style={{ textDecoration: 'none', color: 'black', cursor: 'pointer', fontSize: 16 }}>
                                            <Text>{post.title}</Text>
                                        </Link>
                                    </Title>
                                    <Text size="sm" color="dimmed" mb="xs">{post.date}</Text>
                                    <Text size="sm" style={{ textAlign: "justify" }}>{post.description}</Text>
                                </Card>
                            </Grid.Col>
                        ))}
                    </Grid>
                </>}
        </Container>
    );
}

export default BlogPostContent;
